import Utils from "../../services/Utils.js";
import {getCurrentBalance} from "../../js/api/balance.js";
import { _t } from "../../services/TranslationService.js";
import { getLogo, getTextLogo, getTitle } from "../../js/constants/global-variables.js";

let Header = {
    render: async () => {

        let logedInBtn;
        let myBetsBtn;
        let profileBtn;
        let logedInState;
        let usersBtn;
        let createUsersBtn;
        let myProfileBtn;
        let access_token = localStorage.getItem('access_token');
        let profileName = localStorage.getItem("name");
        let username = localStorage.getItem("username");
        let profileSurname = localStorage.getItem("surname");
        let profileType = localStorage.getItem("role");
        let hierarchyOfUsers = ['User', 'Agent', 'Manager', 'Supermanager', 'Administrator', 'Superadmin'];

        if ((access_token == '') || (access_token == null)) {
            logedInState = false;
            logedInBtn = `<div class="menuItem loginBtn registerBtn">${_t('Join')}</div>` + `<div class="menuItem loginBtn">${_t('Hyr')}</div>`
            profileBtn = ``
            myBetsBtn = ''
            usersBtn = ''
            createUsersBtn = ''
        } else {
            let user = Utils.parseJwt(access_token);

            if (profileType === 'Manager' || profileType === 'Agent' || profileType === 'Supermanager' || profileType === 'Administrator' || profileType === 'Superadmin') {
                logedInBtn = '';
                usersBtn = `<a href="#/Users">${_t('Lista e Perdoruesve')}</a>`;
                createUsersBtn = `<a href="#/createnewuser">${_t('Krijo')} ${hierarchyOfUsers.indexOf(profileType) > -1 ? hierarchyOfUsers[hierarchyOfUsers.indexOf(profileType) - 1] : _t('Perdorues')} </a>`;
                myProfileBtn = '';//`<a href="#/userprofile/${user.data.id}">MyProfile</a>`;
                myBetsBtn = `<a id="myBetsPage" class="menuItem" href="#/mybetsusers${profileType === 'Agent' ? '-agent' : ''}">${_t('My Bets')}</a>`;

                profileBtn = `<div class="profileWrapper">
                         <a class="profileHandler">
                           <div class="profileMainDetails">
                             <span class="profileBalance">
<!--                                <i class="currentBalanceValue">0.00</i>-->
                                    <i class="currentBalanceNew">
                                        <b>€ 19998.00</b>
                                        <b>LEK 197.00</b>
                                        <b>USD 13.00</b>
                                    </i>
                             </span>
                             <span class="profileName">${username}</span>
                           </div>
                           <div class="profileIcon">
                             <svg class="notHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g fill-rule="evenodd" transform="translate(1 1)" stroke="#26FFBE" fill="none"><path d="M3.903 26.472C6.33 22.46 10.839 20 16 20c5.16 0 9.67 2.459 12.097 6.472A15.963 15.963 0 0 1 16 32a15.963 15.963 0 0 1-12.097-5.528z"/><circle cx="16" cy="16" r="16"/><path d="M16 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/></g></svg>
                             <svg class="hovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g fill-rule="evenodd" transform="translate(1 1)" stroke="#FFF" fill="none"><path d="M3.903 26.472C6.33 22.46 10.839 20 16 20c5.16 0 9.67 2.459 12.097 6.472A15.963 15.963 0 0 1 16 32a15.963 15.963 0 0 1-12.097-5.528z"/><circle cx="16" cy="16" r="16"/><path d="M16 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/></g></svg>
                           </div>
                         </a>
                         <div class="profileDropdown">
                           <div class="arrow-up"></div>
                           <div class="profileDetail">
                             <a href="#/CurrentBalance" class="mainCredit">
                               <span>
<!--                                    <i class="currentBalanceValue"></i>-->
                                    <i class="currentBalanceNew">

                                    </i>
                               </span>
                             </a>
                           </div>
                           <div class="profileNav">
                             ${myProfileBtn}
                             ${usersBtn}
                             ${createUsersBtn}
                             <a href="#/AccountBalance">${_t('Financa')}</a>
                             <a href="#/ChangePassword">${_t('Ndrysho Fjalekalimin')}</a>
                             ${profileType === 'Supermanager' ? `<a href="#/smfinances">${_t('Raporti përqindjes')}</a>` : ""}
                             ${profileType === 'Administrator' ? `<a href="#/jackpot">${_t('Jackpot')}</a>` : ""}
                             <!-- <a href="http://${location.host}/chat">Chat</a> -->
                             <a onclick="openChat()">${_t('Chat')}</a>
                             <a href="./" id="logoutBtn">${_t('Largohu')}</a>
                           </div>
                         </div>
                       </div>`;
            }

            if (profileType === 'User') {
                logedInBtn = '';
                myBetsBtn = `<a id="myBetsPage" class="menuItem" href="#/MyBets">My Bets</a>`;
                profileBtn = `<div class="profileWrapper">
                         <a class="profileHandler">
                           <div class="profileMainDetails">
                             <span class="profileBalance"> <i class="currentBalanceNew">

                             </i></span>
                             <span class="profileName currentBalanceNew"></span>
                           </div>
                           <div class="profileIcon">
                             <svg class="notHovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g fill-rule="evenodd" transform="translate(1 1)" stroke="#26FFBE" fill="none"><path d="M3.903 26.472C6.33 22.46 10.839 20 16 20c5.16 0 9.67 2.459 12.097 6.472A15.963 15.963 0 0 1 16 32a15.963 15.963 0 0 1-12.097-5.528z"/><circle cx="16" cy="16" r="16"/><path d="M16 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/></g></svg>
                             <svg class="hovered" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g fill-rule="evenodd" transform="translate(1 1)" stroke="#FFF" fill="none"><path d="M3.903 26.472C6.33 22.46 10.839 20 16 20c5.16 0 9.67 2.459 12.097 6.472A15.963 15.963 0 0 1 16 32a15.963 15.963 0 0 1-12.097-5.528z"/><circle cx="16" cy="16" r="16"/><path d="M16 17.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/></g></svg>
                           </div>
                         </a>
                         <div class="profileDropdown">
                           <div class="arrow-up"></div>
                           <div class="profileDetail">
                             <a href="#/CurrentBalance" class="mainCredit">
                               <span>${profileName} ${profileSurname}</span>
                               <span> <i class="currentBalanceNew">
                               <b>$ 0.00 </b>

                               <b>€ 100.00 </b>

                               <b>L 2000.00 </b>
                               </i> </span>
                             </a>
                           </div>
                           <div class="profileNav">
                             <a class="myBetsPageBtn" href="#/MyBets">${_t('My Bets')}</a>
                             <a href="#/AccountBalance">${_t('Financa')}</a>
                             <a href="#/ChangePassword">${_t('Ndrysho Fjalekalimin')}</a>
                             ${
                              location.host === 'agwin21.com' ||
                              location.host === 'goldengoal.live' || 
                              location.host === 'oswin21.com'
                                ? `<a onclick="openChat()">${_t('Chat')}</a>` : ''
                             }
                             <a href="./" id="logoutBtn">${_t('Largohu')}</a>
                           </div>
                         </div>
                       </div>`;
            }

            logedInState = true;
        }

        let view =  /*html*/`
            <section class="header" id="headerEvent">
               <div class="headerHelper" hidden>
                 <div class="container">
                   <div class="containerHolder">
                     <div class="leftMenuHeaderHelper">
                       <a href="~/../" class="menuItem active">${_t('Sports')}</a>
                       <a class="menuItem">${_t('Games')}</a>
                       <a class="menuItem" href="../src/#/slots" >${_t('Casino')}</a>
                       <a class="menuItem live-casino-item" onclick="launchLiveCasinoFrame()" >${_t('Live Casino')}</a>
                     </div>
                     <div class="rightMenuHeaderHelper">
                       <a class="menuItem">Contact Us</a>
                       <a class="menuItem headerHide">
                           <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 240.835 240.835" style="enable-background:new 0 0 240.835 240.835;" xml:space="preserve">
                                <g>
                                    <path id="Expand_Less" d="M129.007,57.819c-4.68-4.68-12.499-4.68-17.191,0L3.555,165.803c-4.74,4.74-4.74,12.427,0,17.155   c4.74,4.74,12.439,4.74,17.179,0l99.683-99.406l99.671,99.418c4.752,4.74,12.439,4.74,17.191,0c4.74-4.74,4.74-12.427,0-17.155   L129.007,57.819z"/>
                                </g>
                            </svg>
                        </a>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="headerWrapper">
                 <div class="container">
                   <div class="containerHolder">
                     <a class="burgerBtn">
                        <div class="burgerBtnHolder">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                     </a>
                     <a href="~/../" class="logo ${ location.host === 'sportgamble.net' || location.host === 'localhost:5500' ? 'sportgamble' : '' }">
                      ${
                        (() => {
                          const logo = getLogo();
                          return logo ? `<img src="${logo}" alt="${getTitle()}" />` : `<span>${getTextLogo()}</span>`;
                        })()
                      }
                     </a>  
                     </a>  
                     <div class="mainMenuHolder">
                       <a id="landingPage" class="menuItem active" href="~/../">${_t('Sport')}</a>
                       <a id="inPlayPage" class="menuItem" href="#/InPlay">${_t('Live')}</a>
                       ${myBetsBtn}
                     </div>
                     <div class="rightNavWrapper">
                       ${logedInBtn}
                       ${profileBtn}
                     </div>
                     <div class="searchWrapper">
                       <div class="searchHolder">
                         <div class="searchSubmit">
                           <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.005 512.005" style="enable-background:new 0 0 512.005 512.005;" xml:space="preserve">
                              <g>
                              	<g>
                              		<path d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667    S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6    c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587z     M202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z"/>
                              	</g>
                              </g>
                            </svg>
                         </div>
                         <div class="closeSearchSubmit">
                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                         </div>
                         <input class="headerMainSearch" type="text" placeholder="${_t('Search')}">
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </section>
        `
        return view
    },
    after_render: async () => {

        if (location.host == 'gatepro365.com' || location.host == 'gateplay365.com' || location.host == 'arenaplay365.com') {
            $('body .headerWrapper .logo').html('<span>24/7</span>');
        }
        if (location.host == 'bastks.com') {
          $('body .headerWrapper .logo').html('<span>BASTKS</span>');
          $('body .headerWrapper').css('background-color', '#14805e');
        }


        if (localStorage.getItem('access_token')) {
          var currentBalanceResult = await getCurrentBalance();
          var coins = [];
          var allText = '';

          if (currentBalanceResult && currentBalanceResult.total_coins) {
            var allCoins = currentBalanceResult.total_coins.split('|');

            if (currentBalanceResult.total_coins.includes('|')) {
              var allCoins = currentBalanceResult.total_coins.split('|');
  
              for (let index = 0; index < allCoins.length; index++) {
                const coin = allCoins[index];
                const currency = coin.split(';')[0].split('.')[1];
                coins.push({
                  currency,
                  id: coin.split(';')[0].split('.')[0]
                });
  
                const value = coin.split(';')[1];
                allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
              }
            } else {
              if (currentBalanceResult.currency) {
                coins.push({
                  currency: currentBalanceResult.currency,
                  id: currentBalanceResult.currency_id,
                });
                allText += `<b>${currentBalanceResult.currency} ${parseFloat(currentBalanceResult.total_coins).toFixed(2)} </b>`;
              } else {
                const currency = currentBalanceResult.total_coins.split(';')[0].split('.')[1];
                coins.push({
                  currency,
                  id: currentBalanceResult.total_coins.split(';')[0].split('.')[0]
                });
  
                const value = currentBalanceResult.total_coins.split(';')[1];
                allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
              }
            }
  
            $('.currentBalanceNew').html(allText);
  
            localStorage.setItem('coins', JSON.stringify(coins));
          }
          
        }

        // var swipe_banner = document.getElementById('headerEvent');
        // if(swipe_banner){
        //     Hammer(swipe_banner).on("swipeDown", function() {
        //         $(swipe_banner).addClass('headerScrolledStatic');
        //     });
        // }


    },

};

export default Header;
